import { BiChat } from 'react-icons/bi'
import { HiOutlineMail } from 'react-icons/hi'
import { HelpComponents } from '../../components/HelpComponents'

import styles from './styles.module.scss'

export function Ajuda() {
    return (
        <div className={styles.contentContainer}>
            <HelpComponents
                props={{
                    title: 'Recepção',
                    lists: [
                        ['BiPhoneCall', '(11) 3042-5369'],
                        ['FaWhatsapp', '(11) 97829-5412']
                    ]
            }} />

            <HelpComponents
                props={{
                    title: 'Comercial',
                    lists: [
                        ['BiPhoneCall', '(11) 3042-5369'],
                        ['RiErrorWarningLine', 'Disque 4 ao ser atendido.'],                    
                        ['FaWhatsapp', '(11) 98232-3059'],
                        ['HiOutlineMail', 'comercial@cicom.com.br']
                    ]
                }} />

            <HelpComponents
                props={{
                    title: 'Suporte',
                    lists: [
                        ['BiPhoneCall', '(11) 3042-5369'],
                        ['RiErrorWarningLine', 'Disque 3 ao ser atendido.']
                    ]
                }} />

            <HelpComponents
                props={{
                    title: 'Controle de Qualidade',
                    lists: [
                        ['BiChat', 'Para elogios e/ou reclamações.'],                        
                        ['FaWhatsapp', '(11) 98898-8088']
                    ]
                }} />

            <HelpComponents
                props={{
                    title: 'Horário de Atendimento',
                    lists: [
                        ['HiOutlineClock', 'Segunda a sexta das 08:30 às 17:30.']
                    ]
                }} />

        </div>
    )
}

export default Ajuda